// Angular
import { Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectorRef, ViewRef, AfterViewInit, ViewChild } from '@angular/core';
// RxJS
import { Observable, Subscription } from 'rxjs';
// Object-Path
import * as objectPath from 'object-path';
// Layout
import { LayoutConfigService, MenuConfigService, PageConfigService } from '../../../core/_base/layout';
import { HtmlClassService } from '../html-class.service';
import { LayoutConfig } from '../../../core/_config/layout.config';
import { MenuConfig } from '../../../core/_config/menu.config';
import { PageConfig } from '../../../core/_config/page.config';
// User permissions
import { NgxPermissionsService } from 'ngx-permissions';
// import { currentUserPermissions, Permission } from '../../../core/auth';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../core/reducers';
import { LoaderService } from '../../../shared/sharedServices/loader.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { encrypt } from '../../../utilities/utilityFunctions';
import { SharedService } from '../../../shared/sharedServices/shared.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material';

@Component({
	selector: 'kt-base',
	templateUrl: './base.component.html',
	styleUrls: ['./base.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class BaseComponent implements OnInit, OnDestroy,AfterViewInit {
	// Public variables
	public isMaintenance:boolean;

	selfLayout: string;
	asideDisplay: boolean;
	asideSecondary: boolean;
	subheaderDisplay: boolean;
	fluid: boolean;
	public loader:boolean=false;
	public deviceInfo = null;
	public isDesktopUser: boolean;
	public isiOSUser: boolean;
	public isAndroidUser: boolean;
	public intervaSet:any;
	@ViewChild('childModal',{static:false}) childModal: ModalDirective;
	public modalRef: BsModalRef;
	idleState = 'Not started.';
	idleState1='';
	timedOut = false;
	lastPing?: Date = null;
	// Private properties
	private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	// private currentUserPermissions$: Observable<Permission[]>;


	/**
	 * Component constructor
	 *
	 * @param layoutConfigService: LayoutConfigService
	 * @param menuConfigService: MenuConfifService
	 * @param pageConfigService: PageConfigService
	 * @param htmlClassService: HtmlClassService
	 * @param store
	 * @param permissionsService
	 */
	constructor(
		private layoutConfigService: LayoutConfigService,
		private menuConfigService: MenuConfigService,
		private pageConfigService: PageConfigService,
		private htmlClassService: HtmlClassService,
		private store: Store<AppState>,
		private loaderService:LoaderService,
		private cdr:ChangeDetectorRef,
		private router:Router,
		private idle: Idle, private keepalive: Keepalive,
		private deviceService: DeviceDetectorService,
		private sharedService:SharedService,
		private dialog: MatDialog,private modalService:NgbModal,
		private permissionsService: NgxPermissionsService) {
		// this.loadRolesWithPermissions();

		this.checkIfUserActiveOrNot();
		
		// register configs by demos
		this.layoutConfigService.loadConfigs(new LayoutConfig().configs);
		this.menuConfigService.loadConfigs(new MenuConfig().configs);
		this.pageConfigService.loadConfigs(new PageConfig().configs);

		// setup element classes
		this.htmlClassService.setConfig(this.layoutConfigService.getConfig());

		const subscr = this.layoutConfigService.onConfigUpdated$.subscribe(layoutConfig => {
			// reset body class based on global and page level layout config, refer to html-class.service.ts
			document.body.className = '';
			this.htmlClassService.setConfig(layoutConfig);
		});
		this.unsubscribe.push(subscr);
		this.intervaSet = setInterval(()=>{
			// this.loader = this.loaderService.getValue();
			this.loaderService.getValue().subscribe(value=>{
			this.loader = !!value;
			// this.cdr.detectChanges()
		})
		},100)

		this.loaderService.getValue().subscribe(value=>{
			this.loader = !!value;
			try {
				if (!(this.cdr as ViewRef).destroyed) {
					this.cdr.detectChanges();
				}
			} catch (e) {}
		})
			// this.cdr.detectChanges();

	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
	// 			setInterval(()=>{
	// 	this.checkMaintenance();
	// },15000)

	this.intervaSet = setInterval(()=>{
			// this.loader = this.loaderService.getValue();
			this.loaderService.getValue().subscribe(value=>{
			this.loader = !!value;
			// this.cdr.detectChanges()
		})
		},100)

		this.loaderService.getValue().subscribe(value=>{
			this.loader = !!value;
			try {
				if (!(this.cdr as ViewRef).destroyed) {
					this.cdr.detectChanges();
				}
			} catch (e) {}
		})

		if(!localStorage.getItem('agent')){
			this.deviceCheck()
		}
		const config = this.layoutConfigService.getConfig();
		this.selfLayout = objectPath.get(config, 'self.layout');
		this.asideDisplay = objectPath.get(config, 'aside.self.display');
		this.asideSecondary = objectPath.get(config, 'aside-secondary.self.display');
		this.subheaderDisplay = objectPath.get(config, 'subheader.display');
		this.fluid = objectPath.get(config, 'content.width') === 'fluid';

		// let the layout type change
		const subscr = this.layoutConfigService.onConfigUpdated$.subscribe(cfg => {
			setTimeout(() => {
				this.selfLayout = objectPath.get(cfg, 'self.layout');
			});
		});
		this.unsubscribe.push(subscr);
	
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.unsubscribe.forEach(sb => sb.unsubscribe());
		if (this.cdr && !(this.cdr as ViewRef).destroyed) {
			this.cdr.detectChanges();
		  }
		
		// if(this.intervaSet){
		// 	clearInterval(this.intervaSet)
		// }
		this.asideDisplay=false;
	}


	ngAfterViewInit(): void {		
	}


	deviceCheck() {
		this.deviceInfo = this.deviceService.getDeviceInfo();
		if (this.deviceInfo.os == 'iOS') {
			this.isiOSUser = true;
			this.isAndroidUser = false;
			localStorage.setItem('agent', encrypt('ios'))
		} else if (this.deviceInfo.os == 'Android') {
			this.isAndroidUser = true;
			this.isiOSUser = false;
			localStorage.setItem('agent', encrypt('android'))

		}
		const isMobile = this.deviceService.isMobile();
		const isTablet = this.deviceService.isTablet();
		this.isDesktopUser = this.deviceService.isDesktop();
		if (this.isDesktopUser)
			localStorage.setItem('agent', encrypt('desktop'))
	}

	public checkMaintenance():void{
		this.sharedService.checkMaintenance().subscribe(
			res=>{
				if(res.statusCode){
					if(res.data == 1){
						this.isMaintenance = false;
					}else{
						this.isMaintenance = true;

					}
				}
			}
		)
	}

	public checkIfUserActiveOrNot():void{
		// this.idle.setIdle(1200);
		this.idle.setIdle(7200);
		// sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
		this.idle.setTimeout(30);
		// sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
		this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
		
			
		this.idle.onIdleEnd.subscribe(() => { 
		  this.idleState = 'No longer idle.'
		  this.reset();
		});
					
		this.idle.onTimeout.subscribe(() => {
		  this.childModal.hide();
		  this.idleState = 'Session Timed out!';
		  this.timedOut = true;
		  this.logout();
		});
		
		this.idle.onIdleStart.subscribe(() => {
				this.idleState = 'You\'ve gone idle!'
				this.childModal.show();
		});  
	
		this.idle.onTimeoutWarning.subscribe((countdown) => {
				this.idleState = 'Your session log out in ' + countdown + ' seconds!'
				this.cdr.detectChanges();
		});
	
		// sets the ping interval to 15 seconds
		this.keepalive.interval(15);
		this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
		this.reset();
	
	}

	reset() {
		this.idle.watch();
		//xthis.idleState = 'Started.';
		this.timedOut = false;
	  }
		
		hideChildModal(): void {
		this.childModal.hide();
	  }
	
	  stay() {
		this.reset();
			this.childModal.hide();
	  }

	  public logout() {
		this.sharedService.logoutUser().subscribe(
			(res) => {
				if (res['statusCode'] == 200) {
					localStorage.removeItem('esp-profile-details');
					localStorage.removeItem('ng2Idle.main.expiry');
					this.dialog.closeAll();
          			this.modalService.dismissAll()
					localStorage.removeItem('eduHistory');
					localStorage.removeItem('dob');
					localStorage.removeItem('loginDetails');
					localStorage.removeItem('addresses');
					localStorage.removeItem('primaryNationality');
					localStorage.removeItem('name');
					localStorage.removeItem('Avatar');
					localStorage.removeItem('isForeign');
					localStorage.removeItem('login');
					this.idle.stop();
					document.cookie = "profile=; _ga=0; path=/"
					this.router.navigate(['/auth/login'])
				}
			}
		)
	}
}
